import { render, staticRenderFns } from "./BrowseInlineIframe.vue?vue&type=template&id=07f9bfa8&scoped=true"
import script from "./BrowseInlineIframe.vue?vue&type=script&lang=ts"
export * from "./BrowseInlineIframe.vue?vue&type=script&lang=ts"
import style0 from "./BrowseInlineIframe.vue?vue&type=style&index=0&id=07f9bfa8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9bfa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f9bfa8')) {
      api.createRecord('07f9bfa8', component.options)
    } else {
      api.reload('07f9bfa8', component.options)
    }
    module.hot.accept("./BrowseInlineIframe.vue?vue&type=template&id=07f9bfa8&scoped=true", function () {
      api.rerender('07f9bfa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseInlineIframe.vue"
export default component.exports